import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import TextBoxViewModel from '@/ViewModels/Controls/TextBoxViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';

export default class UrlLinkViewModel extends ControlViewModel {

    /**
     * Das ViewModel für die TextBox
     */
    public textBox: TextBoxViewModel;

    /**
     * Das ViewModel für den Link
     */
    public link: LinkViewModel;

    public showLinkOnly: boolean;

    /**
     * Das ViewModel für die UrlLink
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.textBox = this.paramOrDefault(params.textBox, null);
        this.link = this.paramOrDefault(params.link, null);
        this.showLinkOnly = this.paramOrDefault(params.showLinkOnly, false);
    }
}

ComponentManager.setViewModel('UrlLinkViewModel', UrlLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');